<template>
<div class="chapter">
<div class="inner_page">
<p class="chap_title"><span>Praise for the Writing of Tanith Lee</span></p>
<p class="normal">“Tanith Lee’s lush fiction is marked by exotic venues, precisely and elegantly invoked, populated with passionate characters whose deep emotions drive them to outstanding feats of folly and bravery, sacrifice and love.” —Paul Di Filippo</p>
<p class="normal-p"><span>The Secret Books of Paradys</span></p>
<p class="normal-a">“Fatalistic explorations of a city so sinister it makes H. P. Lovecraft look suburban … a high-quality mixing of eroticism, horror, and aestheticism.… Superb.” —<i>Chicago Sun-Times</i></p>
<p class="normal">“Tanith Lee is an elegant, ironic stylist … one of our very best authors. The prose is powerful, as well as stylish, and the characterizations are acute.” —<i>Locus</i></p>
<p class="normal">“Gorgeous, intoxicating, appalling … Paradys brings to mind M. John Harrison’s <i>Viriconium</i> and Lawrence Durrell’s <i>Alexandra.</i>” —<i>The Washington Post Book World</i></p>
<p class="normal">“Top-notch demonology and atmosphere … it is Lee’s talent for realizing an exquisite and appalling mingling of lust and horror, sexual pleasure and loathing, yearning and revulsion, that drives the book and its readers from cover to cover. Enthralling.” —<i>Kirkus Reviews</i>, starred review, on <i>The Book of the Beast</i></p>
<p class="normal-p"><span>The Lionwolf Trilogy</span></p>
<p class="normal-a">“It’s refreshing to find a fantasy world where the more common medieval backdrop is developed into something deeper; where each page brings something new.” —<i>SFX</i> on <i>No Flame But Mine</i></p>
<p class="normal">“Originality which leaves vivid images in the mind long after … Powerful, poetic.” —<i>Starburst</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?0be3559c